import { ProgramType } from '.';
import { mcDate } from '@/utils';

export interface IMealCountKey {
  siteId: number;
  programId: string;
  mealTypeId: string;
  mealServiceDate: string;
}

export class MealCountKey implements IMealCountKey {
  siteId: number = 0;
  programId: string = '';
  mealTypeId: string = '';
  mealServiceDate: string = '';
  syncDateUtc: string | null = null;

  constructor(
    siteId: number = 0,
    programId: ProgramType = ProgramType.SFSP,
    mealTypeId: string = '',
    mealServiceDate: string = '',
    syncDateUtc: Date | null = null
  ) {
    this.siteId = siteId;
    this.programId = programId;
    this.mealTypeId = mealTypeId;
    if (mealServiceDate) {
      this.mealServiceDate = mcDate.toShortDate(mealServiceDate);
    }
    if (syncDateUtc) {
      this.syncDateUtc = mcDate.toUtcMillis(syncDateUtc);
    }
  }

  /**
   * @summary Combines the properties into a string
   * @description This should match the format in MealCountKey.cs ToString()
   * @returns An uppercase string created by combining: this.programId, this.siteId, this.mealTypeId, and this.mealServiceDate in yyyy-MM-dd format
   */
  toString():string {
    var result = `${this.programId}:${this.siteId}:${this.mealTypeId}:${this.mealServiceDate}`.toUpperCase();
    return result;
  }
}
